import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: stretch;
    background: ${(props: any) => props.theme.colors.interfacePure0};
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);

    @media (max-width: 1300px) {
        gap: 10px;
    }

    @media (max-width: 1020px) {
        gap: 0;
    }



    @media (max-width: 850px) {
        display: none;
    }
`;

export const Aba = styled.div<{
    abaAtiva: boolean;
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: top;
    cursor: pointer;
    gap: 8px;
    padding: 16px 10px;
    font-size: 14px;
    color: ${({ theme, abaAtiva }) => abaAtiva ? theme.colors.primaryRed400 : theme.colors.interfaceText400};
    border-bottom: 2px solid ${({ theme, abaAtiva }) => abaAtiva ? theme.colors.primaryRed400 : 'transparent'};
    user-select: none;
    white-space: nowrap;

    @media (max-width: 1170px) {
        flex-direction: column;
        border-bottom: none;
    }
    
    :hover {
        opacity: 0.8;
    }

    .count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 27px;
        min-width: 16px;
        line-height: 18px;
        padding: 4px;
        font-size: 11px;
        font-weight: 600;
        background-color: ${({ theme, abaAtiva }) => abaAtiva ? theme.colors.primaryRed400 : 'var(--count-badge-bg)'};
        color: ${(props: any) => props.theme.colors.pureWhite};
        border-radius: 4px;
        text-align: center;
    }
`;

// Mobile dropdown components
export const MobileDropdown = styled.div`
    display: none;
    position: relative;

    @media (max-width: 850px) {
        display: block;
        width: 100%;
        background: ${(props: any) => props.theme.colors.interfacePure0};
        border-radius: 12px;
    }
`;

export const MobileCurrentTab = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-radius: 6px;
    width: 100%;
    box-shadow: 0 0 2px  rgba(0, 0, 0, 0.1);
    cursor: pointer;
    background: ${({ isOpen }) => isOpen ? 'rgba(0, 0, 0, 0.02)' : 'white'};
    user-select: none;
    transition: background 0.15s ease;

    .tab-info {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .label {
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryRed400};
        letter-spacing: -0.01em;
    }

    .count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 27px;
        min-width: 16px;
        line-height: 18px;
        padding: 4px;
        font-size: 11px;
        font-weight: 600;
        background: ${({ theme }) => theme.colors.primaryRed400};
        color: ${(props: any) => props.theme.colors.pureWhite};
        border-radius: 4px;
        text-align: center;
    }

    .chevron {
        transform: ${({ isOpen }) => isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition: transform 0.25s ease;
        color: ${({ theme }) => theme.colors.interfaceGray500};
        flex-shrink: 0;
    }

    &:active {
        background: ${({ theme }) => theme.colors.interfacePure100};
    }
`;

export const MobileDropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0px;
    right: 0px;
    background: ${(props: any) => props.theme.colors.interfacePure0};
    border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
    border-radius: 12px ;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 70vh;
    overflow-y: auto;
    animation: slideDown 0.2s ease;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const MobileDropdownItem = styled.div<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    cursor: pointer;
    background: ${({ isActive }) => isActive ? 'rgba(0, 0, 0, 0.02)' : 'white'};
    border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
    user-select: none;
    transition: all 0.15s ease;
    margin: 0 8px;

    &:last-child {
        border-bottom: none;
        border-radius: 0 0 8px 8px;
    }

    &:first-child {
        border-radius: 8px 8px 0 0;
    }

    .label {
        font-size: 15px;
        color: ${({ isActive, theme }) => isActive ? theme.colors.primaryRed400 : theme.colors.interfaceText400};
        font-weight: ${({ isActive }) => isActive ? '600' : '500'};
        letter-spacing: -0.01em;
    }

    .count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 27px;
        min-width: 16px;
        line-height: 18px;
        padding: 4px;
        font-size: 11px;
        font-weight: 600;
        background-color: ${({ theme, isActive }) => isActive ? theme.colors.primaryRed400 : 'var(--count-badge-bg)'};
        color: ${(props: any) => props.theme.colors.pureWhite};
        border-radius: 4px;
        margin-left: 12px;
        text-align: center;
    }

    &:hover {
        background: ${({ isActive }) => isActive ? 'rgba(0, 0, 0, 0.04)' : 'rgba(0, 0, 0, 0.02)'};
        transform: translateX(2px);
    }

    &:active {
        background: ${({ theme }) => theme.colors.interfaceGray100};
        transform: translateX(0);
    }
`;